module.exports = __webpack_public_path__ + "img/_DSC0544 2 3.d10c03e3.png";